// 64 × 64 = 4,096 combinations.

export const ADJECTIVES = [
  'clair','sombre','vif','calme','doux','fort','faible','léger',
  'lourd','haut','bas','large','étroit','rapide','lent','vaste',
  'pâle','noir','blanc','rouge','bleu','vert','jaune','or',
  'argent','cuivre','ambre','pourpre','corail','ivoire','cendré','écarlate',
  'froid','chaud','frais','tiède','sec','humide','tendre','dur',
  'tranchant','mou','lisse','rugueux','brillant','mat','pur','libre',
  'ancien','nouveau','premier','dernier','profond','mince','épais','court',
  'long','rond','carré','fin','grand','petit','noble','sauvage',
]

export const NOUNS = [
  'lune','soleil','étoile','ciel','nuage','vent','pluie','neige',
  'orage','arc','brume','rosée','givre','foudre','aube','crépuscule',
  'mer','fleuve','lac','forêt','montagne','vallée','pierre','sable',
  'grotte','cascade','colline','plaine','île','falaise','rive','pré',
  'rose','lys','iris','pivoine','bleuet','coquelicot','pensée','jasmin',
  'lavande','chêne','érable','saule','cèdre','pin','hêtre','tilleul',
  'oiseau','moineau','hirondelle','rossignol','aigle','faucon','corbeau','héron',
  'cygne','loup','renard','lièvre','cerf','ours','lynx','écureuil',
]
